import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { Text } from '@components/typography';
import { CloudImage } from '@components/CloudImage';
import { themeMediaQuery } from '@utils/styledTheme.util';

export const DisplayAboveMobile = styled(Box)`
  display: block;
  width: 100%;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const DisplayOnMobile = styled(Box)`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
  }
`;

export const WrapperBox = styled(Box)`
  position: relative;
  ${themeMediaQuery('below_sm')} {
    overflow: hidden;
  }
  ${themeMediaQuery('sm')} {
    overflow: visible;
  }
`;

export const StyledBox = styled(Box)`
  position: relative;
  display: flex;
  z-index: 1;
  min-height: var(--sectionMinHeight);
  ${themeMediaQuery('below_sm')} {
    height: 880px;
  }
  @media screen and (min-width: 36rem) {
    height: auto;
  }
  ${themeMediaQuery('sm')} {
    margin-top: 0px;
  }
`;

export const StyledCloudImage = styled(CloudImage)`
  width: 100%;
  ${themeMediaQuery('sm')} {
    width: 160px;
  }
  ${themeMediaQuery('md')} {
    width: 270px;
  }
  @media (min-width: 1400px) {
    width: 100%;
  }
`;

export const CurlArtBox = styled(Box)`
  position: absolute;
  right: 0;
  bottom: -175px;
  ${themeMediaQuery('sm')} {
    bottom: -90px;
  }
  ${themeMediaQuery('md')} {
    bottom: -130px;
  }
  @media (min-width: 1400px) {
    bottom: -175px;
  }
`;

export const TextWrapperBox = styled(Box)`
  position: absolute;
  top: 7vw;
  left: 50%;
  transform: translate(-50%, 0);
  ${themeMediaQuery('below_sm')} {
    top: 15vw;
    left: 20%;
    transform: translate(-13%, 0);
  }
  @media screen and (min-width: 36rem) {
    top: 50vw;
  }
  ${themeMediaQuery('sm')} {
    top: 7vw;
  }
`;

export const StyledText = styled(Text)`
  text-align: center;
  ${themeMediaQuery('sm')} {
    max-width: 440px;
  }
  ${themeMediaQuery('xl')} {
    max-width: 710px;
  }
`;

export const NameStyledText = styled(Text)`
  text-align: center;
`;
